import React from "react";
import { Box, ButtonBase } from "@mui/material";
import { SPORTS } from "../../constants/sportWorkspace";
import { brandRgba } from "../../utils/brandAssets";
import { colors } from "../../theme";

const FanHubSportPills = ({ value, onChange }) => (
  <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
    {SPORTS.map((sport) => {
      const selected = sport.id === value;
      return (
        <ButtonBase
          key={sport.id}
          onClick={() => onChange(sport.id)}
          aria-pressed={selected}
          sx={{
            px: 1.5,
            py: 0.85,
            borderRadius: 999,
            border: `1px solid ${
              selected ? brandRgba(sport.accent, 0.55) : colors.border
            }`,
            bgcolor: selected ? brandRgba(sport.accent, 0.14) : "transparent",
            color: selected ? sport.accent : "text.secondary",
            fontWeight: 700,
            fontSize: 13,
            letterSpacing: 0.3,
          }}
        >
          {sport.label}
        </ButtonBase>
      );
    })}
  </Box>
);

export default FanHubSportPills;
